module.exports = __webpack_public_path__ + "static/media/RDP.12860d64.png";